module.exports = __webpack_public_path__ + "img/playngo.0d4008b6.svg";